import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import { API_LINK } from '../../apiLink/apiLink';

const LibraryMembers = ({ onNavigate }) => {
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchMembers();
    }, []);

    const fetchMembers = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_LINK}/api/library/members`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const result = await response.json();

            if (result.success) {
                setMembers(result.data.members);
            } else {
                setError(result.message || 'Failed to fetch members');
            }
        } catch (err) {
            console.error('Error fetching members:', err);
            setError('An error occurred while fetching members');
        } finally {
            setLoading(false);
        }
    };

    const displayMembers = members.filter(member =>
        (member.name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (member.member_id?.toLowerCase() || '').includes(searchTerm.toLowerCase())
    );

    return (
        <Layout role="librarian" onNavigate={onNavigate} activePage="library-members" pageTitle="Library Members">
            <div style={{ padding: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
                    <h2 style={{ color: '#333', margin: 0 }}>👥 Member Details</h2>
                    <button style={{ backgroundColor: '#238548', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: '500' }}>+ Register New Member</button>
                </div>

                {error && (
                    <div style={{ backgroundColor: '#ffeef0', color: '#e53935', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #ffccd5' }}>
                        <strong>❌ Error:</strong> {error}
                    </div>
                )}

                <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                    <div style={{ padding: '1.5rem', borderBottom: '1px solid #eee' }}>
                        <input
                            type="text"
                            placeholder="Search members by ID or Name..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ width: '100%', maxWidth: '400px', padding: '10px', border: '1px solid #ddd', borderRadius: '6px' }}
                        />
                    </div>
                    <div style={{ overflowX: 'auto' }}>
                        {loading ? (
                            <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>Loading members...</div>
                        ) : (
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f8f9fa', color: '#555', textAlign: 'left' }}>
                                        <th style={{ padding: '15px' }}>Member ID</th>
                                        <th style={{ padding: '15px' }}>Name</th>
                                        <th style={{ padding: '15px' }}>Role</th>
                                        <th style={{ padding: '15px' }}>Department/Course</th>
                                        <th style={{ padding: '15px', textAlign: 'center' }}>Books Issued</th>
                                        <th style={{ padding: '15px' }}>Status</th>
                                        <th style={{ padding: '15px' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {displayMembers.length > 0 ? (
                                        displayMembers.map((member, index) => (
                                            <tr key={member.member_id} style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '15px', fontWeight: '500' }}>{member.member_id}</td>
                                                <td style={{ padding: '15px' }}>{member.name}</td>
                                                <td style={{ padding: '15px', textTransform: 'capitalize' }}>{member.member_type}</td>
                                                <td style={{ padding: '15px' }}>{member.department || member.course || '-'}</td>
                                                <td style={{ padding: '15px', textAlign: 'center' }}>{member.currently_issued || 0}</td>
                                                <td style={{ padding: '15px' }}>
                                                    <span style={{
                                                        backgroundColor: member.status === 'active' ? '#e8f5e9' : '#ffebee',
                                                        color: member.status === 'active' ? '#2e7d32' : '#c62828',
                                                        padding: '4px 10px',
                                                        borderRadius: '12px',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        textTransform: 'capitalize'
                                                    }}>
                                                        {member.status}
                                                    </span>
                                                </td>
                                                <td style={{ padding: '15px' }}>
                                                    <button style={{ color: '#238548', backgroundColor: 'transparent', border: 'none', fontWeight: '600', cursor: 'pointer' }}>Manage</button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>No members found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default LibraryMembers;
